import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/anime';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-chat-smile-2-line text-xl text-primary-500"></i>
              </div>
              <span className="text-lg font-heading text-primary-600 font-bold">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {siteInfo.tagline}，提供全面的动漫大全资源，随时随地满足您的动漫娱乐需求。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#quick-links" className="text-foreground-900 no-underline">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <a href="/category/rexue" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">热门动漫</a>
              </li>
              <li>
                <a href="/category/qihuan" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">新番推荐</a>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#categories" className="text-foreground-900 no-underline">动漫分类</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/category/rexue" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">热血动漫</a>
              </li>
              <li>
                <a href="/category/lianai" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">恋爱动漫</a>
              </li>
              <li>
                <a href="/category/gaoxiao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">搞笑动漫</a>
              </li>
              <li>
                <a href="/category/xuanyi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">悬疑动漫</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#contact-footer" className="text-foreground-900 no-underline">联系我们</a>
            </h4>
            <div className="space-y-2 text-sm text-foreground-600">
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </span>
                {siteInfo.email}
              </p>
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-xs"></i>
                </span>
                {siteInfo.phone}
              </p>
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xs"></i>
                </span>
                {siteInfo.address}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 专注手机动漫的门户网站
          </p>
          <div className="flex items-center gap-4">
            <a href={siteInfo.social.weibo} rel="nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">微博</a>
            <a href={siteInfo.social.bilibili} rel="nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">哔哩哔哩</a>
          </div>
        </div>
      </div>
    </footer>
  );
}